import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-white" data-id="element-164">
      <div className="container mx-auto px-4" data-id="element-165">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-10 bg-sand-50 p-10 md:p-16 rounded-[2.5rem] border border-sand-200 relative overflow-hidden" data-id="element-166">
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold-400/10 rounded-full blur-2xl" data-id="element-167"></div>

          <div className="flex-shrink-0 relative z-10" data-id="element-168">
            <div className="w-24 h-24 rounded-full bg-white flex items-center justify-center shadow-sm border border-sand-100" data-id="element-169">
              <ShieldCheck className="w-12 h-12 text-gold-500" strokeWidth={1.5} data-id="element-170" />
            </div>
          </div>

          <div className="relative z-10 text-center md:text-left" data-id="element-171">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-concrete-900 mb-4" data-id="element-172">
              Garantía de Satisfacción de 7 Días
            </h2>
            <p className="text-concrete-600 text-base font-light leading-relaxed mb-4" data-id="element-173">
              Estoy tan segura de la calidad de este programa que asumo todo el
              riesgo. Tienes 7 días completos para revisar el contenido. Si
              sientes que no es para ti, o no cumple tus expectativas, te
              devuelvo el 100% de tu dinero sin hacer preguntas.
            </p>
            <p className="font-medium text-concrete-800 text-sm tracking-wide uppercase" data-id="element-174">
              Tu compra es 100% segura y libre de riesgos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}